import "../sass/_index.scss";

import Component_OffsetScroll from "./components/offsetScroll";
import Component_ScrollHandler from "./components/scrollHandler";
import Component_UpdateDynamicAnchors from "./components/updateDynamicAnchors";
import Component_SmoothScroll from "./components/smoothScroll";
import Component_Parallax from "./components/heroParallax";
import Component_SmartGrid from "./components/smartGrid";
import { initContactPopup } from "./components/contactPopup.js";

// Alte Komponenten die sofort laufen
Component_ScrollHandler();
Component_UpdateDynamicAnchors();
Component_OffsetScroll();
Component_SmoothScroll();
Component_Parallax();
Component_SmartGrid();

// Contact Popup MUSS nach DOMContentLoaded laufen!
document.addEventListener("DOMContentLoaded", () => {
	initContactPopup();
});
